module.exports = __webpack_public_path__ + "static/media/cancel.8697ad17.png";